import { atom } from "jotai";

export const isReconnectingEdgeInProgressAtom = atom<boolean>(false);
isReconnectingEdgeInProgressAtom.debugLabel =
  "isReconnectingEdgeInProgressAtom";
